module.exports = __webpack_public_path__ + "img/PETANQUE.bfe5361a.png";